import React from "react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/SectionDivider";

const POINTS = [
  "Under RBI's Liberalised Remittance Scheme (LRS), every Indian resident can remit up to USD 250,000 per year.",
  "Funds can be used for global investments and international securities — fully legal.",
  "No hawala. No grey channels. Completely above board.",
  "A family of four can access USD 1,000,000 every year, compounding globally.",
];

const LRSWindow = () => {
  return (
    <section
      id="lrs"
      data-testid="lrs-section"
      className="relative bg-[#080808] py-24 md:py-32 overflow-hidden"
    >
      {/* Decorative arcs */}
      <svg
        className="absolute -right-20 top-10 w-[480px] h-[480px] opacity-[0.05] pointer-events-none"
        viewBox="0 0 200 200"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="100" cy="100" r="90" stroke="#C9960C" strokeWidth="0.6" />
        <circle cx="100" cy="100" r="70" stroke="#C9960C" strokeWidth="0.6" />
        <circle cx="100" cy="100" r="50" stroke="#C9960C" strokeWidth="0.6" />
        <circle cx="100" cy="100" r="30" stroke="#C9960C" strokeWidth="0.6" />
      </svg>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <Reveal>
          <Eyebrow testId="lrs-eyebrow">The LRS Window</Eyebrow>
          <h2
            data-testid="lrs-heading"
            className="font-serif-display text-[#C9960C] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl"
          >
            Your Legal Gateway to the World
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <Reveal delay={0.1}>
            <ul className="space-y-6">
              {POINTS.map((p, idx) => (
                <li key={idx} className="flex items-start gap-5">
                  <span className="font-serif-display text-[#C9960C]/70 text-2xl leading-none mt-1">
                    {`0${idx + 1}`}
                  </span>
                  <p className="text-[#F8F6F0]/85 text-[16px] sm:text-[17px] leading-relaxed">{p}</p>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.25}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div
                data-testid="lrs-stat-individual"
                className="bg-[#1C1C1C] border border-[#C9960C]/50 border-t-2 border-t-[#C9960C] p-8"
              >
                <p className="text-[11px] tracking-[0.32em] uppercase text-[#C9960C] mb-4">
                  Per Individual
                </p>
                <div className="font-serif-display text-[#F5D485] leading-none">
                  <div className="text-3xl">USD</div>
                  <div className="text-5xl sm:text-6xl mt-1">250,000</div>
                </div>
                <p className="mt-4 text-[#F8F6F0]/65 text-sm">Per year, under RBI LRS</p>
              </div>
              <div
                data-testid="lrs-stat-family"
                className="bg-[#1C1C1C] border border-[#C9960C]/50 border-t-2 border-t-[#C9960C] p-8"
              >
                <p className="text-[11px] tracking-[0.32em] uppercase text-[#C9960C] mb-4">
                  Per Family of Four
                </p>
                <div className="font-serif-display text-[#F5D485] leading-none">
                  <div className="text-3xl">USD</div>
                  <div className="text-5xl sm:text-6xl mt-1">1 Million</div>
                </div>
                <p className="mt-4 text-[#F8F6F0]/65 text-sm">Per year, deployable globally</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default LRSWindow;
